<template>
<div class="main-panel">
    <top-navbar></top-navbar>
    <div class="content">

        <div class="card">
            <FlashMessage :position="'right top'"></FlashMessage>

            <div class="card-header">
                <h4 class="title">Edit Lead Note</h4>
            </div>
            <div class="card-body">
                <form @submit.prevent="submit">
                    <div class="row">
                        <div class="col-md-4">
                            Name: <label>{{leadnote.name}}</label>
                        </div>
                        <div class="col-md-4">
                            Mobile: <label>{{leadnote.number}}</label>
                        </div>
                        <div class="col-md-4">
                            Email: <label>{{leadnote.email}}</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            Address: <label>{{leadnote.addline1}}, {{leadnote.addline2}}, {{leadnote.country}}, {{leadnote.state}}, {{leadnote.city}}, {{leadnote.pincode}}</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            Enquiry: <label>{{leadnote.enquiry}}</label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-3">
                            Promotion: <label>{{leadnote.promotion}}</label>
                        </div>
                        <div class="col-md-3">
                            Referral: <label>{{leadnote.referral}}</label>
                        </div>
                        <div class="col-md-3">
                            Followdate: <label>{{leadnote.followdate}}</label>
                        </div>
                        <div class="col-md-3">
                            Assign User: <label>{{leadnote.assignusername}}</label>
                        </div>
                    </div><br>

                    <div class="row">
                        <div class="col-md-6">
                            <label>Note<em style="color:red">*</em></label>
                            <textarea class="form-control" v-model.trim="$v.note.$model" placeholder="Enter note"></textarea>
                            <div class="error" v-if="submitted && !$v.note.required">Please enter note</div>
                            <div class="text">
                                <button type="submit" class="btn btn-secondary dashboard">Add</button>&nbsp;
                                <router-link to="/admin/dashboard/lead"><button type="button" class="btn btn-secondary dashboard">Cancel</button></router-link>

                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="card">
                                <div class="card-header pb-3">
                                    All Notes
                                </div>
                                <div class="card-body scroll">
                                    <Scroll-Div height="150px" view-class="yourclassname">
                                        <div v-if="allnote!=''">
                                        <div v-for="(data) in allnote" v-bind:key="data.noteid" >
                                            <p class="card-text">{{data.note}}</p>
                                            <h6 style="font-size: smaller;">-{{data.assignusername}}-{{ data.created_at | formatDate }}</h6>
                                            <hr>
                                        </div>
                                    </div>
                                        <div v-else>
                                            <h6 style="text-align: center;">No Notes</h6>
                                        </div>
                                    </Scroll-Div>
                                </div>
                            </div>
                        </div>
                    </div>

                </form>
            </div>
        </div>

    </div>
    <content-footer></content-footer>
</div>
</template>

<script>
import TopNavbar from "../../Dashboard/Layout/TopNavbar.vue";
import ContentFooter from "../../Dashboard/Layout/ContentFooter.vue";
import ValidationError from "src/components/UIComponents/ValidationError.vue";
import Auth from '../../../Auth.js';

import {
    required,
    minLength,
    maxLength,
    between,
    email,
} from "vuelidate/lib/validators";
export default {
    name: 'addLead',
    components: {
        TopNavbar,
        ContentFooter,
        ValidationError,
    },

    data() {
        return {
            submitted: false,
            leadnote: '',
            allnote: '',
            note: '',
            auth: '',
        }
    },

    validations: {
        note: {
            required
        }
    },

    methods: {

        async allnotes() {
            const allnote = await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/note/` + this.$route.params.id);
            this.allnote = allnote.data.data;
        },

        submit() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                this.axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/noteadd`, {
                        note: this.note,
                        createduser: this.auth.id,
                        enquiryid: this.leadnote.enquiryid,
                    })
                    .then(({
                        data
                    }) => {
                        this.flashMessage.success({
                            message: 'Note Added Successfully',
                        });
                        this.allnotes();

                    })
                // .catch((error) => {
                //     console.log(error);
                // });

            }
        },
    },

    async mounted() {
        this.allnotes();

        const leadnote = await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/lead/edit/` + this.$route.params.id);
        this.leadnote = leadnote.data.data;

        this.auth = Auth.user;
    },

};
</script>

<style lang="scss">
.scrollable {
    overflow-y: scroll;
}
</style>
